module.exports = __webpack_public_path__ + "static/img/學會章程.png";